export default "__VITE_ASSET__c749b9c0__"